webpackJsonp([35783957827783],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row items' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-4' },
	        _react2.default.createElement(
	          'a',
	          { href: '/about' },
	          _react2.default.createElement('div', { className: 'ratio block-me' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '/about' },
	            'Hire me!'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Your company needs an Anthropologist.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-4' },
	        _react2.default.createElement(
	          'a',
	          { href: '/projects/auspost' },
	          _react2.default.createElement('div', { className: 'ratio block-auspost' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '/projects/auspost' },
	            'Australia Post'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'User Experience research in the postal industry'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-4' },
	        _react2.default.createElement(
	          'a',
	          { href: '/projects/sunsmart' },
	          _react2.default.createElement('div', { className: 'ratio block-sunsmart' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '/projects/sunsmart' },
	            'UX Case Study: SunSmart 2014'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'An app from start to finish'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row items' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-4' },
	        _react2.default.createElement(
	          'a',
	          { href: '/projects/age-friendly-communities' },
	          _react2.default.createElement('div', { className: 'ratio block-project1' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '/projects/age-friendly-communities' },
	            'Age Friendly Communities'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'A narrative research about age-friendly communities.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-4' },
	        _react2.default.createElement(
	          'a',
	          { href: '/projects/imagineering-dis-ability' },
	          _react2.default.createElement('div', { className: 'ratio block-imagineering' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '/projects/imagineering-dis-ability' },
	            'Imagineering Dis/Ability'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'A cultural anthropological research about the perception of dis/abled people and prosthetics.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-4' },
	        _react2.default.createElement(
	          'a',
	          { href: '/projects/familymovies-moviefamilies' },
	          _react2.default.createElement('div', { className: 'ratio block-project3' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '/projects/familymovies-moviefamilies' },
	            'Family Movies : Movie Families'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Research about private home movie images from a cultural anthropological perspective.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row items' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-4' },
	        _react2.default.createElement(
	          'a',
	          { href: '/projects/travel-phenomena' },
	          _react2.default.createElement('div', { className: 'ratio block-travel' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '/projects/travel-phenomena' },
	            'Travel Phenomena '
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Research about the time and space perception of Backpacker and Flashpacker.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-4' },
	        _react2.default.createElement(
	          'a',
	          { href: '/projects/capoeira' },
	          _react2.default.createElement('div', { className: 'ratio block-project5' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '/projects/capoeira' },
	            'Capoeira: A Thick Description'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'An ethnographical movie of Capoeira'
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-04d5489dcb313304c046.js